<template>
  <div
    :class="['flex items-center justify-center w-full px-1 sm:px-16 lg:px-32 xl:px-64 py-2 mt-1',
    variant === 'error' && 'bg-red-600 text-white']"
  >
    {{ message }}
  </div>
</template>

<script>
export default {
  name: "Alert",
  props: {
    message: {
      type: String,
    },
    variant: {
      type: String,
    },
  },
};
</script>
